

























































































import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {Period} from '@/enums/Period'
import CockpitRequest from '@/model/request/CockpitRequest'
import * as Helper from '@/helpers'
import {Collection, ID} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import ItDateInput from '@/components/itrack/ItDateInput.vue'
import moment from 'moment'

@Component({
  components: {ItDateInput},
})
export default class FilterCockpit extends Mixins(MixinMember) {
  @Prop({required: true}) value!: CockpitRequest
  @Prop({type: Boolean}) blockDate?: boolean

  Period = Period

  model = new Carga()
  collection = new Collection(Carga)

  async mounted() {
    await this.value.allMotorista.query()
  }

  @Watch('value.updateAutomatically')
  updateAutomaticallyEvent(val: boolean) {
    Helper.setUpdateAutomaticallyCockpit(val)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }

  memberRespEvent(id: ID) {
      this.value.idRespFiltroFilial = id
  }

  @Watch('value.period')
  updateDateByPeriod() {
    if (this.value.period === Period.WEEKLY) {
      this.value.dataInicio = moment().subtract('6', 'days').format()
      this.value.dataFim = moment().format()
    }
  }

  @Watch('value.dataInicio')
  updateDate() {
    this.value.dataFim = this.value.dataInicio ? moment(this.value.dataInicio).add(6, 'days').format() : null
  }
}
